export default __webpack_public_path__ + "static/media/skillset-end-user-support.3949b413.svg";